import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "Is Shopify good for web development?",
    answer: `<p>Yes, Shopify is one of the greatest web development platforms accessible, ideal for easy, quick, and cost-effective solutions that involve selling. The themes are highly adaptable, with sophisticated APIs for creating and managing Internet enterprises for a variety of users.</p> `,
  },
  {
    question: "How much does it cost to get a Shopify website built? ",
    answer: `<p>Web design for a Shopify store might range between $3,000 and $6,000 for a site with minimal functionality. The cost may vary based on the design's complexity, required innovations, and integration needs. For a more precise price customized for the needs of your unique project, use our cost calculator.</p> `,
  },
  {
    question: "What is a Shopify development company?",
    answer: `<p>Shopify website development company involved in designing websites using the Shopify platform based on the needs of the business. Their services include creating custom themes and apps, launching new stores, migrating existing businesses, and providing ongoing support.</p>  `,
  },
  {
    question: "How much does it cost to hire a Shopify developer?",
    answer: `<p>The cost of hiring a Shopify developer ranges between $50 and $150 per hour depending on the expertise level of the specialist, and the complexity of the work completed. </p>`,
  },
  {
    question: "What are Shopify web development services?",
    answer: `<p>Shopify website development services entail a range of products concerning the development and improvement of online stores. Services include theme customization, app development, store setup, platform migration, and ongoing support to enhance the shopping experience.</p>`,
  },
  {
    question: "Can you help me redesign my current Shopify website?",
    answer: ` <p>Yes, TekRevol can assist you in enhancing your current Shopify website and enhance its appearance and functions. We will talk with you about how your website can be built in a way that is visually appealing while also tapping into the client market to increase sales.</p> `,
  },
  {
    question:
      "How long does it take for a Shopify web development company to deliver the live project?",
    answer: `
    <p>Another important aspect that is often overlooked when designing a Shopify store is the time frame in which the project will be implemented. </p>
    <ul>
      <li>Basic Store: 1-5 days (depending on the selected theme and additional customization)</li>
      <li>Standard Store: 2-4 weeks (moderate customization and development work).</li>
      <li>Advanced Store: 4-8 weeks (entails a lot of customization and other features).</li>
    </ul>
    `,
  },
  {
    question:
      "Are your Shopify professionals capable of designing SEO-optimized stores?",
    answer: ` <p>Yes, we have the most skilled Shopify specialists who understand Google SERP trends and algorithms. They plan your Shopify development so that your Shopify website and stores are merged as one.</p> `,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ backgroundColor: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>
                <span>Shopify Website</span> Development FAQs
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
